import { connect } from 'react-redux';
import FirstInvalidFieldSpy from './FirstInvalidFieldSpy';

const mapStateToProps = state => ({
  breakpoint: state.getIn(['app', 'breakpoint']),
});

export default connect(mapStateToProps)(FirstInvalidFieldSpy);
